import meter1 from "../assets/img/meter1.svg";
import meter2 from "../assets/img/meter2.svg";
import meter3 from "../assets/img/meter3.svg";
import { CircularProgressbar } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';

import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import arrow1 from "../assets/img/arrow1.svg";
import arrow2 from "../assets/img/arrow2.svg";
import colorSharp from "../assets/img/color-sharp.png"

export const Skills = () => {
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };

  return (
    <section className="skill" id="skills">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="skill-bx wow zoomIn">
              <h2>Skills</h2>
              <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.<br></br> Lorem Ipsum has been the industry's standard dummy text.</p>
              <Carousel responsive={responsive} infinite={true} className="owl-carousel owl-theme skill-slider">
                <div className="item">

                  <CircularProgressbar
                    value={90}
                    text={`90%`}
                    className="htmlSkill"
                    styles={{
                      text: {
                        fill: '#ffffff'
                      }
                    }}
                  />


                  <h5>HTML/CSS</h5>
                </div>
                <div className="item">
                <CircularProgressbar
                    value={60}
                    text={`60%`}
                    className="jsSkill"
                    styles={{
                      text: {
                        fill: '#ffffff'
                      }
                    }}
                  />
                  <h5>Javascript</h5>
                </div>
                <div className="item">
                <CircularProgressbar
                    value={45}
                    text={`45%`}
                    className="reactSkill"
                    styles={{
                      text: {
                        fill: '#ffffff'
                      }
                    }}
                  />
                  <h5>React.js</h5>
                </div>
                <div className="item">
                <CircularProgressbar
                    value={75}
                    text={`75%`}
                    className="softSkill"
                    styles={{
                      text: {
                        fill: '#ffffff'
                      }
                    }}
                  />
                  <h5>Software Development</h5>
                </div>
              </Carousel>
            </div>
          </div>
        </div>
      </div>
      <img className="background-image-left" src={colorSharp} alt="Image" />
    </section>
  )
}
